import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName } from '../utils';

/** 出力ファイル形式 */
enum OutputFileFormat {
  csv = 'CSV',
  csvForFileImport = 'CSV_FOR_FILE_IMPORT',
}

const nameConfig = {
  csv: new Map([
    [Locale.ja, 'CSV'],
    [Locale.en, 'CSV'],
  ]),
  csvForFileImport: new Map([
    [Locale.ja, 'CSV(データ取込用)'],
    [Locale.en, 'CSV For Data Import'],
  ]),
};

const toDisplay = enumToName(OutputFileFormat, nameConfig);
const toDisplayWithPrefix = enumToName(OutputFileFormat, nameConfig, { prefix: true });

export const outputFileFormat = {
  enum: OutputFileFormat,
  nameConfig,
  toDisplay,
  toDisplayWithPrefix,
};
export type { OutputFileFormat };
